module.exports = __webpack_public_path__ + "img/camera-slash.8b5ecac9.svg";